import { useState, useCallback } from "react";
import { useStudentNavigation } from "../hooks/useStudentNavigation";

export const useSearchUIState = () => {
  const { navigateToStudentDetails } = useStudentNavigation();

  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: "",
  });
  const [profilesModal, setProfilesModal] = useState({
    open: false,
    profiles: [],
    searchValues: null,
  });

  const handleProfileSelect = useCallback(
    (selectedProfile, searchValues, selectedBranch) => {
      navigateToStudentDetails(selectedProfile, searchValues, selectedBranch);
      setProfilesModal({ open: false, profiles: [], searchValues: null });
    },
    [navigateToStudentDetails],
  );

  const openErrorSnackbar = useCallback(
    (message) => setErrorSnackbar({ open: true, message }),
    [],
  );

  const openProfilesModal = useCallback(
    (profiles, searchValues) =>
      setProfilesModal({ open: true, profiles, searchValues }),
    [],
  );

  const closeErrorSnackbar = useCallback(
    () => setErrorSnackbar({ open: false, message: "" }),
    [],
  );

  const closeProfilesModal = useCallback(
    () => setProfilesModal({ open: false, profiles: [], searchValues: null }),
    [],
  );

  return {
    errorSnackbar,
    openErrorSnackbar,
    closeErrorSnackbar,
    profilesModal,
    openProfilesModal,
    closeProfilesModal,
    handleProfileSelect,
  };
};
